import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index.js'
import Login from '../components/login/Login.vue'
import HelloWorld from '../components/HelloWorld'
import Orcamento from '../components/Orcamento'
import Clientes from '../components/Clientes'
import DetalheCliente from '../components/DetalheCliente'
import ConsultaOrcamento from '../components/ConsultaOrcamento'
Vue.use(VueRouter)

  const routes = [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld,
      meta: {
        requiresAuth: true
      }    
    },
    {
      path: '/orcamento/:id/:tipo',
      name: 'Orcamento',
      component: Orcamento,
      meta: {
        requiresAuth: true
      }    
    },
    {
      path: '/clientes',
      name: 'Clientes',
      component: Clientes,
      meta: {
        requiresAuth: true
      }
    },
      {
        path: '/consultaorcamento',
        name: 'ConsultaOrcamento',
        component: ConsultaOrcamento,
        meta: {
          requiresAuth: true
        }     
    },
    {
      path: '/detalhecliente/:id',
      name: 'DetalheCliente',
      component: DetalheCliente,
      meta: {
        requiresAuth: true
      }     
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})

export default router
